<template>
  <div class="body-container">
    <navbar v-if="!isLandingPage" />

    <vue-toast v-show="!isLandingPage" ref="infoToast"></vue-toast>

    <transition name="fade">
      <router-view></router-view>
    </transition>

    <overlay v-if="!isLandingPage" />

    <cookie-bar />

    <foot />
  </div>
</template>

<script>
  import VueToast from 'vue-toast';

  import Navbar from '@/components/Navbar';
  import Overlay from '@/components/Overlay';
  import CookieBar from '@/components/CookieBar';
  import Foot from '@/components/Foot';

  export default {
    name: 'app',
    computed: {
      isLandingPage() {
        return this.$route.name === 'LandingPage';
      },
    },
    components: {
      VueToast,
      Navbar,
      Overlay,
      CookieBar,
      Foot,
    },
  };

</script>

<style>
  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    src: local('Poppins Regular'), local('Poppins-Regular'), url(https://fonts.gstatic.com/s/poppins/v3/gG8m82oGcrBJF727xHU04fY6323mHUZFJMgTvxaG2iE.woff2) format('woff2');
    unicode-range: U+02BC, U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200B-200D, U+20A8, U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB;
  }

  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    src: local('Poppins Regular'), local('Poppins-Regular'), url(https://fonts.gstatic.com/s/poppins/v3/F4YWuALHubF63LLQPw0rMfY6323mHUZFJMgTvxaG2iE.woff2) format('woff2');
    unicode-range: U+0100-024F, U+1E00-1EFF, U+20A0-20AB, U+20AD-20CF, U+2C60-2C7F, U+A720-A7FF;
  }

  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    src: local('Poppins Regular'), local('Poppins-Regular'), url(https://fonts.gstatic.com/s/poppins/v3/HLBysyo0MQBO_7E-DWLwzg.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215;
  }

  body,
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-family: "Poppins", sans-serif !important;
  }

  body {
    font-size: 16px !important;
  }

  .main-container {
    position: relative;
    margin-left: 340px;
    margin-right: 40px;
    padding-bottom: 100px;
    min-height: 92vh;
  }

  .body-container {
    position: relative;
  }

  .blueimp-gallery-display-fix {
    opacity: 1 !important;
  }

  .fade-enter-active {
    transition-property: opacity !important;
    transition-duration: .20s !important;
  }

  .fade-leave-active {
    transition-property: opacity !important;
    transition-duration: .20s !important;
  }

  .fade-enter-active {
    transition-delay: .20s !important;
  }

  .fade-enter {
    opacity: 0 !important;
  }

  .fade-leave-active {
    opacity: 0 !important;
  }
  /* spinner */

  .cross::after,
  .cross::before {
    background-color: #f44336 !important;
  }

  .check::after,
  .check::before {
    background-color: #8BC34A !important;
  }
  /* toast */

  .vue-toast-manager_container {
    z-index: 1 !important;
  }

  .vue-toast_container._error .vue-toast_message {
    background-color: rgba(255, 0, 0, 1) !important;
  }

  .vue-toast_container._success .vue-toast_message {
    background-color: rgba(235, 46, 75, 1) !important;
  }

  .vue-toast_close-btn {
    right: 22px !important;
  }

  .vue-toast_message {
    text-align: right;
  }

  .vue-toast_container._info .vue-toast_message {
    background: -webkit-linear-gradient(42deg, #f2514c, #fa326f) !important;
    background: linear-gradient(42deg, #f2514c, #fa326f) !important;
  }

  .info-toast {
    display: table;
  }

  .info-toast img {
    width: 35px;
  }

  .info-toast div {
    padding-left: 20px;
    display: table-cell;
    vertical-align: middle;
    margin-bottom: 10px;
    font-size: 20px;
    font-weight: 500;
  }

  .info-toast a {
    text-decoration: none;
  }

  @media (max-width: 425px) {
    .info-toast div {
      font-size: 16px;
    }

    .info-toast img {
      display: none;
    }
  }

  .link {
    text-decoration: none;
    color:#f44336;
  }
</style>



// WEBPACK FOOTER //
// App.vue?7421ba02